import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const tabsStyles = tv({
    slots: {
        root: `
      iris:inline-flex
      iris:flex-col
      iris:gap-(--comp-space-gap-tabs)
    `,
        list: `
      iris:flex
      iris:items-center
      iris:justify-center
    `,
        trigger: `
      iris:flex
      iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:font-(family-name:--comp-type-font-tabs-pill-label)
      iris:text-(length:--comp-type-size-tabs-pill-label)
      iris:font-(--comp-type-weight-tabs-pill-label)!
      iris:tracking-(--comp-type-tracking-tabs-pill-label)
      iris:data-[state=active]:cursor-default
    `,
        icon: `
      iris:h-6
      iris:w-6
    `,
    },
    variants: {
        variant: {
            pill: {
                list: `
          iris:h-(--comp-size-height-tabs-pill)
          iris:rounded-(--comp-size-radius-tabs-pill)
          iris:border-1
          iris:border-(--comp-color-border-tabs-pill-container)
          iris:bg-(--comp-color-background-tabs-pill-container)
          iris:text-(--comp-color-content-tabs-pill-label-rest)
        `,
                trigger: `
          iris:h-(--comp-size-height-tabs-pill)
          iris:rounded-(--comp-size-radius-tabs-pill)
          iris:border-0
          iris:bg-(--comp-color-background-tabs-pill-tab-rest)
          iris:px-(--comp-space-padding-tabs-pill-horizontal-narrow)
          iris:py-(--comp-space-padding-tabs-pill-vertical)
          iris:leading-(--comp-type-leading-tabs-pill-label)
          iris:whitespace-nowrap
          iris:transition-all
          iris:duration-(--comp-motion-duration-tabs-pill)
          iris:ease-(--comp-motion-easing-tabs-pill)
          iris:hover:bg-(--comp-color-background-tabs-pill-tab-hover)
          iris:hover:text-(--comp-color-content-tabs-pill-label-hover)
          iris:active:bg-(--comp-color-background-tabs-pill-tab-pressed)
          iris:active:text-(--comp-color-content-tabs-pill-label-pressed)
          iris:data-[state=active]:border
          iris:data-[state=active]:border-(length:--comp-size-border-tabs-pill-selected)
          iris:data-[state=active]:border-(--comp-color-border-tabs-pill-tab-selected)
          iris:data-[state=active]:bg-(--comp-color-background-tabs-pill-tab-selected)
          iris:data-[state=active]:font-(family-name:--comp-type-font-tabs-pill-label)
          iris:data-[state=active]:font-(--comp-type-weight-tabs-pill-label-selected)!
          iris:data-[state=active]:text-(--comp-color-content-tabs-pill-label-selected)
          iris:sm:px-(--comp-space-padding-tabs-pill-horizontal-default)
        `,
            },
            text: {
                list: `
          iris:flex
          iris:gap-(--comp-space-gap-tabs-text-tab-narrow)
          iris:border-b
          iris:border-b-(--comp-color-border-tabs-text-container)
          iris:sm:gap-(--comp-space-gap-tabs-text-tab-default)
        `,
                trigger: `
          iris:flex
          iris:flex-col
          iris:items-center
          iris:justify-center
          iris:gap-(--comp-space-gap-tabs-text-tab-icon)
          iris:border-b-(length:--comp-size-border-tabs-text-tab-rest)
          iris:border-(--comp-color-border-tabs-text-tab-rest)
          iris:border-t-(--base-size-border-none)
          iris:border-r-(--base-size-border-none)
          iris:border-l-(--base-size-border-none)
          iris:p-(--base-space-px-0)
          iris:pb-(--comp-space-gap-tabs-text-tab-label)
          iris:font-(family-name:--comp-type-font-tabs-text-label)
          iris:text-(length:--comp-type-size-tabs-text-label)
          iris:leading-(--comp-type-leading-tabs-text-label)
          iris:font-(--comp-type-weight-tabs-text-label)!
          iris:tracking-(--comp-type-tracking-tabs-text-label)
          iris:text-(--comp-color-content-tabs-text-label-rest)
          iris:transition-all
          iris:duration-(--comp-motion-duration-tabs-text)
          iris:ease-(--comp-motion-easing-tabs-text)
          iris:hover:border-b-(length:--comp-size-border-tabs-text-tab-hover)
          iris:hover:border-(--comp-color-border-tabs-text-tab-hover)
          iris:hover:text-(--comp-color-content-tabs-text-label-hover)
          iris:active:border-b-(length:--comp-size-border-tabs-text-tab-pressed)
          iris:active:border-(--comp-color-border-tabs-text-tab-pressed)
          iris:active:text-(--comp-color-content-tabs-text-label-pressed)
          iris:data-[state=active]:border-b-(length:--comp-size-border-tabs-text-tab-selected)
          iris:data-[state=active]:border-(--comp-color-border-tabs-text-tab-selected)
          iris:data-[state=active]:font-(--comp-type-weight-tabs-text-label-selected)!
          iris:data-[state=active]:text-(--comp-color-content-tabs-text-label-selected)
        `,
            },
        },
        inverse: {
            true: {
                trigger: focusStyles.inverse,
                list: "",
            },
            false: {
                trigger: focusStyles.default,
            },
        },
    },
    compoundVariants: [
        {
            variant: "pill",
            inverse: true,
            class: {
                trigger: `
          iris:bg-(--comp-color-background-tabs-pill-tab-inverse-rest)
          iris:text-(--comp-color-content-tabs-pill-label-inverse-rest)
          iris:hover:bg-(--comp-color-background-tabs-pill-tab-inverse-hover)
          iris:hover:text-(--comp-color-content-tabs-pill-label-inverse-hover)
          iris:active:bg-(--comp-color-background-tabs-pill-tab-inverse-pressed)
          iris:active:text-(--comp-color-content-tabs-pill-label-inverse-pressed)
          
          iris:data-[state=active]:border
          iris:data-[state=active]:border-(length:--comp-size-border-tabs-pill-selected)
          iris:data-[state=active]:border-(--comp-color-border-tabs-pill-tab-inverse-selected)
          iris:data-[state=active]:bg-(--comp-color-background-tabs-pill-tab-inverse-rest)
          iris:data-[state=active]:text-(--comp-color-content-tabs-pill-label-inverse-selected)
        `,
                list: `
          iris:border-(--comp-color-border-tabs-pill-container-inverse)
          iris:bg-(--comp-color-background-tabs-pill-container-inverse)
          iris:text-(--comp-color-content-tabs-pill-label-inverse-rest)
        `,
            },
        },
        {
            variant: "text",
            inverse: true,
            class: {
                trigger: `
          iris:border-b-(length:--comp-size-border-tabs-text-tab-rest)
          iris:border-(--comp-color-border-tabs-text-tab-inverse-rest)
          iris:border-t-(--base-size-border-none)
          iris:border-r-(--base-size-border-none)
          iris:border-l-(--base-size-border-none)
          iris:text-(--comp-color-content-tabs-text-label-inverse-rest)
          iris:hover:border-b-(length:--comp-size-border-tabs-text-tab-hover)
          iris:hover:border-(--comp-color-border-tabs-text-tab-inverse-hover)
          iris:hover:text-(--comp-color-content-tabs-text-label-inverse-hover)
          iris:active:border-b-(length:--comp-size-border-tabs-text-tab-pressed)
          iris:active:border-(--comp-color-border-tabs-text-tab-inverse-pressed)
          iris:active:text-(--comp-color-content-tabs-text-label-inverse-pressed)
          iris:data-[state=active]:border-b-(length:--comp-size-border-tabs-text-tab-selected)
          iris:data-[state=active]:border-(--comp-color-border-tabs-text-tab-inverse-selected)
          iris:data-[state=active]:font-(--comp-type-weight-tabs-text-label-selected)!
          iris:data-[state=active]:text-(--comp-color-content-tabs-text-label-inverse-selected)
        `,
                list: "iris:border-b-(--comp-color-border-tabs-text-container-inverse)",
            },
        },
    ],
});

export { tabsStyles as default };
